import React from 'react';
import Article from '../../components/article/Article';

import './blog.css';
const image = 'https://picsum.photos/200'
const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">Stay updated, <br /> with lastest financial news.</h1>
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupA">
        <Article imgUrl={image} date="June 12, 2022" text="Are we actually practising democracy in Nigeria?" />
      </div>
      <div className="gpt3__blog-container_groupB">
        <Article imgUrl={'https://picsum.photos/10'} date="Jan 20, 2022" text="There is no one who loves pain itself, who seeks after it and wants to have it," />
        <Article imgUrl={'https://picsum.photos/100'} date="Feb 12, 2021" text="There is no one who loves pain itself, who seeks after it and wants to have it," />
        <Article imgUrl={'https://picsum.photos/130'} date="March 3, 2021" text="There is no one who loves pain itself, who seeks after it and wants to have it," />
        <Article imgUrl={'https://picsum.photos/150'} date="April 14, 2021" text="There is no one who loves pain itself, who seeks after it and wants to have it," />
      </div>
    </div>
  </div>
);

export default Blog;
